import React, { useContext } from 'react';
import { Button, SelectOption } from '../../../components';
import CreateCharge from '../../../pages/charge/CarryOutCharge/CreateCharge/CreateCharge';
import InvoicesUploadCharges from '../../../pages/charge/CarryOutCharge/InvoicesUploadCharges/InvoicesUploadCharges';
import Context from '../../../store/context';

import { ReactComponent as PlusIcon } from '../../../assets/icons/PlusIcon.svg';

/**
 * Componente reutilizable para el botón "Agregar cuenta" en los tabs de cargos
 * Unifica la funcionalidad entre "Pendientes de cobro", "Cobros realizados" y "Pagos recibidos"
 * 
 * @param {Object} props
 * @param {Function} props.refetch - Función para refrescar la lista después de crear/agregar cuentas
 * @param {boolean} props.allowBulkUpload - Si permite carga masiva (default: true)
 * @param {string} props.tabType - Tipo de tab: 'pending', 'made', 'received' (default: 'pending')
 */
const AddChargeButton = ({ refetch, allowBulkUpload = true, tabType = 'pending' }) => {
  const {
    modal: { showModal }
  } = useContext(Context);

  const optionSelected = option => {
    if (option === 'one') {
      // Crear cuenta individual
      showModal(<CreateCharge refetch={refetch} />);
    } else if (option === 'some' && allowBulkUpload) {
      // Carga masiva (solo si está permitida)
      showModal(<InvoicesUploadCharges refetch={refetch} />);
    }
  };

  const headerActionHandler = () => {
    showModal(
      <SelectOption 
        optionSelected={optionSelected} 
        type='facture' 
        disabled={!allowBulkUpload} 
      />
    );
  };

  return (
    <Button onClick={headerActionHandler} Icon={PlusIcon} size='md'>
      Agregar cobro
    </Button>
  );
};

export default AddChargeButton;
